const mutations = {
  setShippingAddress(state, address) {
    state.shippingAddress = address
  },
  setCheckoutSummary(state, summary) {
    state.orderSummary = summary
  },
  referralCodeApplied(state, payload) {
    state.referralCode = payload
  },
  removeReferralCode(state) {
    state.referralCode = null
  }
}

export default mutations
